<script setup lang="ts">
import Translator from "@/utils/common/Translator.ts";
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import MapLocationIcon from "@/assets/widgetIcons/MapLocationIcon.vue";
import ErrorTooltip from "@/components/EditView/ErrorTooltip.vue";
import MapLocationFieldWidgetUtil from "@/utils/editView/widgets/MapLocationFieldWidgetUtil.ts";
import {ref} from "vue";
import {QInput} from "quasar";
import {focusAndSelectInput} from "@/utils/common/NamaVueWidget.ts";

const props = defineProps<WidgetProps>();
const fieldId = props.field.id!;
const fieldUtil = new MapLocationFieldWidgetUtil(props.presenter, props.fieldMetaData);

const location = fieldUtil.formattedValue();

async function onClick(event: Event) {
  window.selectedLocation = location.value ?? '';
  window.open("locpicker.html?q=" + (location.value || ""), "locationPicker", "height=800,width=900");
  event.preventDefault();
  window.onLocPickerClose = async () => {
    if (fieldUtil.isFieldDisabled(props.forceEnableField))
      return;
    await fieldUtil.onLocationPicked(window.selectedLocation, window.selectedAddress);
  }
}
const input = ref<QInput>()

function focus() {
  focusAndSelectInput(input);
}

function canReceiveFocus() {
  return !fieldUtil.isFieldDisabled(props.forceEnableField);
}

defineExpose({focus, canReceiveFocus})
</script>

<template>
  <WidgetContainer :field="field"
                   :entityType="presenter.entityType"
                   :isSpanned="isSpanned" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
                   :isFieldRequired="fieldUtil.isFieldRequired()" :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
                   :isInsideComposite="isInsideComposite">
    <template v-slot:widget="{ showAsPassword, doNotGoToNextWithEnter }">
      <q-input outlined dense hide-bottom-space
               :readonly="fieldUtil.isFieldDisabled(forceEnableField)"
               :id="fieldId" ref="input"
               autocomplete="off"
               :type="showAsPassword ? 'password' : 'text'"
               :error="!!props.presenter.fetchFieldErrorMsg(fieldId)"
               class="nama-customize-dense-input nama-focused-input"
               :class="{'nama-field-input-disabled':fieldUtil.isFieldDisabled(forceEnableField),'nama-field-input':!fieldUtil.isFieldDisabled(forceEnableField)}"
               input-class="nama-input-class !tw-px-[3px]"
               :model-value="location" @update:model-value="fieldUtil.onPartialUserInput"
               @focus="fieldUtil.onFocus" @blur="fieldUtil.onBlur"
               @keydown.enter="(e)=>{ if (!doNotGoToNextWithEnter) $emit('navigateToNext',{keyboardEvent:e}) }">
        <template v-slot:prepend>
          <q-avatar square @click.stop="onClick" rel="noopener noreferrer"
                    :title="Translator.translateId('mapLocation')"
                    class="tw-ml-1 nama-avatar-hover tw-cursor-pointer">
            <MapLocationIcon class="tw-w-5 tw-h-5 nama-widget-icon-hover nama-widget-icon"/>
          </q-avatar>
        </template>
        <ErrorTooltip v-if="presenter.fetchFieldErrorMsg(fieldId)" :error-msg="presenter.fetchFieldErrorMsg(fieldId)"/>
      </q-input>
    </template>
  </WidgetContainer>
</template>

<style>

</style>
